<template>
    <div class="about">
        <div class="pg-header">
            <div><label class="title">大屏管理</label></div>
            <div class="algr">
                <div class="pg-nav">
                    <i class="icon-home"></i>
                    <span>系统管理</span>|
                    <span>大屏管理</span>
                </div>
            </div>
        </div>

        <div class="table-wrap">
            <div class="action-bar">
                <el-button type="primary" size="mini" round @click="showDlg('add')">新增配置</el-button>
            </div>
            <el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
                :data="list.data" v-loading="isLoading" >
                <el-table-column prop="dashboardType" label="配置类型">
                    <template slot-scope="scope">
                        {{ 
                            {
                                1:'慢病分组',
                                2:'科室分组'
                            }[scope.row.dashboardType] }}
                    </template>
                </el-table-column>
                <el-table-column prop="dashboardCode" label="Code"></el-table-column>
                <el-table-column prop="description" label="Code描述" ></el-table-column>
                <el-table-column prop="dataStr" label="关联数据"> </el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                        <div class="tab-action">
                            <el-tooltip content="修改" placement="top" :enterable="false">
                                <i class="el-icon-edit-outline" @click="showDlg('edit',scope.row.id)"></i>
                            </el-tooltip>
                            <el-popconfirm confirmButtonText='确定' title="确定删除吗？" @confirm="delForm(scope.row.id)">
                                <el-tooltip content="删除" slot="reference" placement="top" :enterable="false">
                                    <i class="el-icon-delete"></i>
                                </el-tooltip>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-row>
                    <el-col :span="12">
                        <div class="record">当前是第<span v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
                                v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
                        </div>
                        <div class="record">总计<span v-text="list.total"></span>条记录</div>
                    </el-col>
                    <el-col :span="12" style="text-align: right;">
                        <el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
                            :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
                            :current-page="list.current" :page-size="filter.pageSize" :total="list.total"
                            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-dialog :title="dlgType=='add'?'新增配置':'修改配置'" width="630px" center :visible.sync="dlgActive">
			<el-form ref="form" label-width="120px" :rules="rules" :model="form">
				<el-form-item label="配置类型" prop="dashboardType">
                    <el-select v-model="form.dashboardType" :style="{ width: '100%' }" placeholder="请选择">
                        <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>
                <el-form-item label="Code" prop="dashboardCode">
					<el-input v-model="form.dashboardCode"></el-input>
				</el-form-item>
				<el-form-item label="Code描述" prop="description">
					<el-input v-model="form.description"></el-input>
				</el-form-item>
                <el-form-item  label="选择科室" prop="dataId" v-if="form.dashboardType==2">
					<el-cascader ref="depCascader" v-if="depActive" filterable :props="deptProps" v-model="form.dataId"></el-cascader>
				</el-form-item>
				<el-form-item  label="患者分组" prop="dataId" v-if="form.dashboardType==1">
					<el-select size="small" filterable v-model="form.dataId" placeholder="分组">
						<el-option v-for="item in groupList" :key="item.id" :label="item.groupingName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>
    </div>
</template>
  
<script>
import api from '@/service/api.js';

export default {
    data() {
        return {
            list: {
                current: 1,
                total: 0,
                pageSize: 0,
                data: null
            },
            filter: {
                dashboardType:0,//1慢病分组2科室
                pageNumber: 1,
                pageSize: 10,
            },
            form: {
                dashboardCode:'',
                dashboardType:'',
                dataId:'',
                description:'',
                dataStr:''
            },
            dlgType:'',
            dlgActive:false,
            rules: {
                    dashboardCode: {required: true, message: '请输入', trigger: 'blur'},
					dashboardType: {required: true, message: '请选择', trigger: 'change'},
					dataId: {required: true, message: '请选择', trigger: 'change'},
					description: {required: true, message: '请输入', trigger: 'blur'},
				},
            options:[
                {
                    value:1,
                    label:'慢病分组'
                },
                {
                    value:2,
                    label:'科室分组'
                },
            ],
            isLoading:false,
            depActive:false,
            sysOrgList:[],
            groupList:[],
            groupConfig:{
                groupingName: '',
                pageNumber: 1,
                pageSize: 1000
            }
        }
    },
    created() {
        this.loadList();
        // 机构下拉
		this.loadSysOrgAll({dataState: 0});
        // 患者分组 数据
		api.getPatientGroupList(this.groupConfig).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.groupList = res.data;
			}
		});
        this.loadDept()
    },
    mounted() {
        // 监听页面显示隐藏
        document.addEventListener('visibilitychange', this.handleVisiable)
    },
    destroyed() {
        document.removeEventListener('visibilitychange', this.handleVisiable)
    },
    methods: {
        async loadList() {
            this.isLoading = true;
            let res = await api.getDashboardConfigList(this.filter);
            if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }

            this.list.total = +res.total;
            this.list.current = this.filter.pageNumber;
            this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
            this.list.data = res.data;
            this.isLoading = false;
        },
        async loadSysOrgAll() {
			let res = await api.getSysOrgAll();
			this.sysOrgList = res.data;
		},
        loadDept() {
			// 科室
			this.deptProps = {
				multiple: false,
				lazy: true,
				lazyLoad: async (node, resolve) => {
					const { level } = node;
					let nodes;
					if (level === 0) {
						nodes = this.sysOrgList.map((item)=>({
							value: item.id,
							label: item.orgName,
						}));
						resolve(nodes);
					} else {
						const res = await api.getDeptListBySysOrgId(node.value);
						if (res.code === 1000 && res.data && res.data[0]) {
							nodes = res.data[0].depts.map((item)=>({
								value: item.depId,
								label: item.depName,
								leaf: 'leaf',
							}));
						}
						resolve(nodes);
					}
				}
			}
			this.depActive = true;
		},
        async saveForm() {
            this.$refs['form'].validate(async (valid)=>{
				if (valid) {
                    let obj={...this.form};
                console.log(obj.dataId,'=========999');
                    if(this.form.dashboardType==2){
                        obj.dataId=obj.dataId[1];
                    }
                    console.log(obj.dataId,'-----------obj');
                    let res;
                    if(this.dlgType=='add'){
                        res=await api.addDashboardConfig(obj);
                    } else if(this.dlgType=='edit'){
                        res=await api.updateDashboardConfig(obj)
                    }
                    if(res.code==1000){
                            this.$message.success(`${this.dlgType=='add'?'保存':'修改'}成功`);
                            this.loadList();
                            this.closeDlg()
                        } else {
                            this.$message.error(res.message);
                        }
                }

            })
           
        },
        async delForm(id){
            let res=await api.delDashboardConfigById({
                id
            })
            if(res.code==1000){
                this.$message.success('删除成功');
                this.loadList();
            } else {
                this.$message.error(res.message)
            }
        },
        async showDlg(type,id){
            if(type=='edit'){
                let res=await api.getDashboardConfigById({id});
                this.form={...res.data};
            }
            this.dlgType=type;
            this.dlgActive=true;
        },
        closeDlg(){
            this.dlgActive=false;
            this.resetForm();
        },
        resetForm(){
            this.form={
                dashboardCode:'',
                dashboardType:'',
                dataId:'',
                description:'',
            }
        },
        handleSizeChange(v) {
            this.filter.pageSize = v;
            this.filter.pageNumber = 1;
            this.loadList();
        },
        handleCurrentChange(v) {
            this.filter.pageNumber = v;
            this.loadList();
        },
        handleVisiable(e) {
            // 关闭新开页面，回到列表页，刷新列表数据
            if (e.target.visibilityState == "visible") {
                this.loadList()
            }
        },
    }
}
</script>
  
<style lang="less" scoped>
@import '@/assets/style/var';
.action-bar{
    padding-top: 20px;
}
</style>
  